export const DSLightColors = {
  black: '#000000',
  white: '#FFFFFF',
  /**
   * Полупрозрачный чёрный. Число — прозрачность, а не оттенок.
   * Одинаковый в светлой и тёмной теме: затемнение должно оставаться
   * затемнением.
   */
  blackTransparent: {
    50: '#00000080',
    70: '#000000B2',
  },
  gray: {
    50: '#F9FAFC',
    100: '#F2F5F8',
    200: '#E4E8EE',
    300: '#CED5DE',
    400: '#98A3B4',
    500: '#687386',
    600: '#495566',
    700: '#354153',
    800: '#1F2939',
    900: '#0F1728',
  },
  primary: {
    50: '#EEF5FE',
    100: '#E0EEFF',
    200: '#BEDAFD',
    300: '#93C4FC',
    400: '#60A5F9',
    500: '#3B81F4',
    600: '#2D67D8',
    700: '#1D4ED6',
    800: '#1E40AD',
    900: '#1E3A8A',
  },
  orange: {
    50: '#FEFAEA',
    100: '#FDF2C6',
    200: '#FCE58A',
    300: '#FBD24D',
    400: '#FABE24',
    500: '#F49D0B',
    600: '#D87706',
    700: '#B35309',
    800: '#91400E',
    900: '#76340F',
  },
  red: {
    50: '#FFF5F5',
    100: '#FEE3E3',
    200: '#FED7D7',
    300: '#FEB2B2',
    400: '#FC8181',
    500: '#F56565',
    600: '#E53E3E',
    700: '#C53030',
    800: '#9B2C2C',
    900: '#822727',
  },
  green: {
    50: '#EFFCF3',
    100: '#DBFBE6',
    200: '#BAF6CF',
    300: '#86EEAB',
    400: '#4ADC7F',
    500: '#22C35D',
    600: '#16A24A',
    700: '#157F3D',
    800: '#166434',
    900: '#14522D',
  },
  purple: {
    50: '#F9F4FE',
    100: '#F2E7FE',
    200: '#E8D4FE',
    300: '#D7B3FD',
    400: '#BE83FA',
    500: '#A754F5',
    600: '#9233E8',
    700: '#7D22CC',
    800: '#6921A5',
    900: '#561C84',
  },
} as const;
